export class EntityActions {
  static readonly ADD_ENTITIES = 'shared/entity/ADD_ENTITIES';
}

export class AuthActions {
  static readonly VALIDATE_REQUEST = 'shared/auth/VALIDATE_REQUEST';

  static readonly LOGIN_REQUEST = 'shared/auth/LOGIN_REQUEST';
  static readonly LOGIN_SUCCESS = 'shared/auth/LOGIN_SUCCESS';
  static readonly LOGIN_ERROR = 'shared/auth/LOGIN_ERROR';

  static readonly LOGOUT_REQUEST = 'shared/auth/LOGOUT_REQUEST';
  static readonly LOGOUT_SUCCESS = 'shared/auth/LOGOUT_SUCCESS';
  static readonly LOGOUT_ERROR = 'shared/auth/LOGOUT_ERROR';
}

export class UsersActions {
  static readonly LOAD_REQUEST = 'shared/user/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'shared/user/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'shared/user/LOAD_ERROR';

  static readonly LOAD_LIST_SUCCESS = 'shared/user/LOAD_LIST_SUCCESS';

  static readonly RESET_SUCCESS_MESSAGE = 'shared/user/RESET_SUCCESS_MESSAGE';

  static readonly SAVE_REQUEST = 'shared/user/SAVE_REQUEST';
  static readonly SAVE_SUCCESS = 'shared/user/SAVE_SUCCESS';
  static readonly SAVE_ERROR = 'shared/user/SAVE_ERROR';

  static readonly CREATE_SUCCESS = 'shared/user/CREATE_SUCCESS';

  static readonly SET_CURRENT_PAGE = 'shared/user/SET_CURRENT_PAGE';
}

export class OrganizationActions {
  static readonly LOAD_REQUEST = 'shared/organization/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'shared/organization/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'shared/organization/LOAD_ERROR';

  static readonly LOAD_LIST_SUCCESS = 'shared/organization/LOAD_LIST_SUCCESS';

  static readonly SET_CURRENT_PAGE = 'shared/organization/SET_CURRENT_PAGE';
}

export class LocationActions {
  static readonly LOAD_REQUEST = 'shared/location/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'shared/location/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'shared/location/LOAD_ERROR';

  static readonly LOAD_LIST_SUCCESS = 'shared/location/LOAD_LIST_SUCCESS';

  static readonly SET_CURRENT_PAGE = 'shared/location/SET_CURRENT_PAGE';
}

export class TransactionActions {
  static readonly LOAD_REQUEST = 'shared/transaction/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'shared/transaction/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'shared/transaction/LOAD_ERROR';

  static readonly LOAD_LIST_SUCCESS = 'shared/transaction/LOAD_LIST_SUCCESS';

  static readonly SET_CURRENT_PAGE = 'shared/transaction/SET_CURRENT_PAGE';

}

export class BalanceActions {
  static readonly LOAD_REQUEST = 'sender/balance/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'sender/balance/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'sender/balance/LOAD_ERROR';
}

export class SettingsActions {
  static readonly LOAD_KYC_REQUEST = 'shared/settings/LOAD_KYC_REQUEST';
  static readonly LOAD_KYC_SUCCESS = 'shared/settings/LOAD_KYC_SUCCESS';
  static readonly LOAD_KYC_ERROR = 'shared/settings/LOAD_KYC_ERROR';

  static readonly SAVE_KYC_REQUEST = 'shared/settings/SAVE_KYC_REQUEST';
  static readonly SAVE_KYC_SUCCESS = 'shared/settings/SAVE_KYC_SUCCESS';
  static readonly SAVE_KYC_ERROR = 'shared/settings/SAVE_KYC_ERROR';
}

export class InformationActions {
  static readonly LOAD_REQUEST = 'shared/info/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'shared/info/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'shared/info/LOAD_ERROR';
}

export class DepartmentActions {
  static readonly LOAD_REQUEST = 'shared/department/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'shared/department/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'shared/department/LOAD_ERROR';

  static readonly LOAD_LIST_SUCCESS = 'shared/department/LOAD_LIST_SUCCESS';
}

export class PasswordResetActions {
  static readonly LOAD_REQUEST = 'shared/password-reset/LOAD_REQUEST';
  static readonly LOAD_SUCCESS = 'shared/password-reset/LOAD_SUCCESS';
  static readonly LOAD_ERROR = 'shared/password-reset/LOAD_ERROR';
  static readonly LOAD_SEND_SUCCESS = 'shared/password-reset/LOAD_SEND_SUCCESS';
}

